<template>
  <!-- <el-dialog
      :model-value="props.visible"
      title="选择素材"
      width="1100"
      top="6vh"
      destroy-on-close
      append-to-body
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div>
      <div class="content-wrap">
        <course-content-library
            ref="libraryChooseRef"
            by-choose
        />
      </div>

      <div class="my-footer">
        <el-button
            type="primary"
            style="margin-left: 10px;"
            @click="onConfirm">确定
        </el-button>
        <el-button @click="emit('update:visible', false)">关闭</el-button>
      </div>
    </div>
  </el-dialog> -->
  <selected-material-dialog v-model:visible="open" @confirm="onConfirm"/>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import selectedMaterialDialog from '@/views/education/courseContentLibrary/cmp/selectedMaterialDialog.vue';

const props = defineProps({
  currentRow: {
    type: Object,
    default: () => {},
  },
  accept: {
    // 选择素材类型，根据中文写死文件类型
    type: String,
    validator: (val) => ['', '视频', '课件', '月刊', '工具包', '学员课件'].includes(val),
    default: '',
  },
  acceptType: {
    type: Array,
    default: () => [],
  },
  limit: {
    // 最多能选择几个文件
    type: Number,
    default: undefined,
  },
});
const emit = defineEmits(['confirm']);
const open = defineModel('visible', { type: Boolean, required: true, default: false });

function onOpen() {}

const libraryChooseRef = ref({});

// type枚举：MP4、PDF、Word、PPT、Excel、M3U8、其他
function onConfirm(list) {
  const rows = [...list];
  if (!rows || rows.length === 0) {
    ElMessage.warning('请选择素材');
    return;
  }
  if (rows.some((s) => s.fileType == '0')) {
    // 存在文件夹
    ElMessage.warning('选中的类型不能含有文件夹！');
    return;
  }
  if (props.limit != null && rows.length > props.limit) {
    ElMessage.warning(`最多只能选择${props.limit}个文件`);
    return;
  }

  if (props.accept == '视频') {
    if (rows.some((s) => s.type != 'MP4' && s.type != 'M3U8')) {
      ElMessage.warning('选中的文件类型只能为视频！');
      return;
    }
  } else if (props.accept == '课件') {
    if (rows.some((s) => s.type != 'PDF' && s.type != 'PPT' && s.type != 'Excel' && s.type != 'Word' && s.type != 'Zip' && s.type != 'Rar')) {
      ElMessage.warning('选中的文件类型只能为pdf、ppt、excel、word、zip、rar！');
      return;
    }
  } else if (props.accept == '月刊') {
    if (rows.some((s) => s.type != 'PDF' && s.type != 'PPT' && s.type != 'Excel' && s.type != 'Word')) {
      ElMessage.warning('选中的文件类型只能为pdf、ppt、excel、word！');
      return;
    }
  } else if (props.accept == '工具包') {
    if (rows.some((s) => s.type == 'MP4' || s.type == 'M3U8')) {
      ElMessage.warning('选中的文件类型不能为视频！');
      return;
    }
  } else if (props.accept == '学员课件') {
    if (rows.some((s) =>!['PDF','Excel'].includes(s.type))) {
      ElMessage.warning('选中的文件类型只能为pdf、excel！');
      return;
    }
  }

  if (props.acceptType.length > 0) {
    if (rows.some((s) => !props.acceptType.some((type) => s.type.toLowerCase() == type.toLowerCase()))) {
      ElMessage.warning(`只能选择${props.acceptType.join('、').toUpperCase()}格式的文件！`);
      return;
    }
  }
  emit('confirm', rows);
}

function closedModal() {
  open.value = false;
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
}

.content-wrap {
  overflow-y: hidden;
  height: calc(88vh - 150px);
}
</style>
